import {
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDateFormats
} from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';

import { BillingFilter } from './models/billing.model';
import { eProductDisplayNames } from './models/fi-products.model';

export class Constants {
  static appConfiguration;
}

export const MOMENT_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'MM-DD-YYYY'
  },
  display: {
    dateInput: 'MM-DD-YYYY',
    monthYearLabel: 'MMMM Y',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM Y'
  }
};

export const GLOBAL_DATE_CONFIG: any[] = [
  { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
  { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
  { provide: MAT_DATE_LOCALE, useValue: 'en-US' }
];

export const BILLING_STATUS: BillingFilter[] = [
  { value: 'all', viewValue: 'All' },
  { value: 'active', viewValue: 'Active' },
  { value: 'remitted', viewValue: 'Remitted' },
  { value: 'voided', viewValue: 'Voided' }
];

export const BILLING_PRODUCTS: BillingFilter[] = [
  { value: 'all', viewValue: 'All' },
  { value: 'gap', viewValue: eProductDisplayNames.gap },
  { value: 'mmp', viewValue: eProductDisplayNames.mmp },
  { value: 'powerSports', viewValue: eProductDisplayNames.powerSports },
  { value: 'vehicleReturn', viewValue: eProductDisplayNames.vehicleReturn },
  { value: 'pep', viewValue: eProductDisplayNames.pep },
  { value: 'mba', viewValue: eProductDisplayNames.ppm },
  { value: 'keyProtection', viewValue: eProductDisplayNames.keyProtection },
  { value: 'cvp', viewValue: eProductDisplayNames.cvp },
  { value: 'sp', viewValue: eProductDisplayNames.sd }
];
